<modal id="ngx-pdf-modal-23">
  <div >
    <button
      type="button"
      class="close "
      aria-label="Close"
      (click)="closeModal('ngx-pdf-modal-23')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <h3 >{{ title }}</h3>
  </div>
 
  <div class="modal-body" *ngIf="!hideSignatureModalSection">
    <div *ngIf="listOfSignature.length < 1">
      <p style="margin-left: 5px;">Not any saved signature found!</p>
    </div>
    <div *ngFor="let sign of listOfSignature; let i=index;" class="choose-img-container">
      <img [src]="sign.url" class="choose-img" alt="" (click)="selectSignatureByIndex(i)" [ngClass]="{'active-sign-img': sign.active}">
    </div>
  </div>
  <div class="modal-body" [hidden]="!hideSignatureModalSection" >
    <div class="signature-pad">
      <div class="signature-pad--body" >
        <canvas
        [hidden]="isPreSelected"
          #sPad
          id="sPad"
          width="430"
          style="touch-action: none;cursor: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABMUlEQVQ4T6WTPW6EMBBGP9CmS5OUvkJ+pNSZhgMhQZkcIC2IUyDEHSKkkbZ0kt2OO+ymoKNI5Eiz8hoWDJnSIz+9b8YOsLKYOQOQADgS0a1ggjU8ZjYgAzxV3/c3URR9LwZaZgMXIgqWAu8B7Jl5D+BuJN1hCVBm9gTgg5m/ADy4UF+gOzOBfgJ4tKC5D1DMXBmBSvyUiGaBg206VIFmRJSa3pThJTPX1ETezb3DOTO5nwP4M5sC+poZkAGelRt5tdmY4b/MzoBJkiRN02Rd16Ft26nvPZjZaGRm/jENrTXiOL4EHJ3ZWuCsmR35jZlfzIEduSgKie9lZgPflVLPZVluwjA8bd1E11p7m9nAHsBGKdVXVXUljbqu0zzPB+9samPy9Y4ArgEwgC2A17lLU/1f/2V1dIZ5YYoAAAAASUVORK5CYII=')  2 20,
          crosshair;"
        ></canvas>
         <img [src]="preSelectedSign" *ngIf="isPreSelected" width="430" alt="">

      </div>
    </div>
    <div style="margin: 5px; text-align: center;">
      <span
        class="btn-custom  dot-btn"
        [ngStyle]="{'background-color': item ? item : 'red'}"
        [style.border]=" item == signaturePad?.penColor ? '1px solid #3e3e3e' : '1px solid #ffffff0d'"
        *ngFor="let item of colors"
        (click)="changeColor(item)"
      ></span>
    </div>

    <div style="text-align: center;" *ngIf="fromEditor">
      <p>Size:</p>
      <div class="btn-group" btnRadioGroup name='size'  >
        <button class="btn-custom  btn-light-custom selectable-btn" (click)="setSize('Small')" [ngClass]="{'selectable-btn-active': size == 'Small'}">Small</button>
        <button class="btn-custom  btn-light-custom selectable-btn" (click)="setSize('Normal')"  [ngClass]="{'selectable-btn-active': size == 'Normal'}">Normal</button>
        <button class="btn-custom  btn-light-custom selectable-btn" (click)="setSize('Large')"  [ngClass]="{'selectable-btn-active': size == 'Large'}">Large</button>
      </div>
        </div>



    <hr *ngIf="fromEditor" />
    <div style="text-align: center">
      <button id="undo" class="btn-custom  btn-light-custom" *ngIf="isSignable && fromEditor" (click)="openChooseSignModal()">Choose</button>
      <button id="undo" class="btn-custom  btn-light-custom" (click)="undo()">Undo</button>
      <button id="clear" class="btn-custom  btn-light-custom" (click)="clear()">Clear</button>
    </div>
  </div>
  <div class="modal-footer"  *ngIf="hideSignatureModalSection">
   
    <button type="button" class="btn-custom btn-dark" (click)="saveThisImage()" *ngIf="(!isSignable || isSignable) && !fromEditor">
      {{ closeBtnName }}
    </button>
    <button type="button" class="btn-custom btn-dark" (click)="applySignOnPdf()" *ngIf="isSignable && fromEditor">
      {{ closeBtnName }}
    </button>

    <button
      type="button"
      class="btn-custom  btn-light-custom"
      (click)="closeModal('ngx-pdf-modal-23')"
    >
      {{ "Close" }}
    </button>
  </div>
  <div class="modal-footer"  *ngIf="!hideSignatureModalSection">
    
    <button type="button" class="btn-custom btn-dark" (click)="setThisImage()" >
      Done
    </button>

    <button
      type="button"
      class="btn-custom  btn-light-custom"
      (click)="closeChooseSignModal()"
    >
      {{ "Close" }}
    </button>
  </div>
</modal>



<span id="ngx-pdf-sdk">
  <div class="HeaderToolsContainer" data-element="toolsHeader">
    <div class="Header Tools">
      <div class="HeaderItems">
        <span style="display: flex" *ngIf="formData.length > 0" >
          <div
            data-element="signatureToolGroupButton"
            class="tool-group-button "
            [hidden]="formData.length < 1"
          >
            <button
              class="Button active "
              data-element="menuButton"
              aria-label="Menu"
              [hidden]="formData.length < 1"
              (click)="toggleSideNav()"
            >
              <div class="Icon" style="margin-bottom: 4px">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" [hidden]="formData.length < 1">
                  <path
                    class="cls-1"
                    [hidden]="formData.length < 1"
                    d="M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z"
                  ></path>
                </svg>
              </div>
            </button>
          </div>
        </span>

        <!-- <span class="scrol-menu-container" style="display: flex"> -->

        <div class="spacer  hide-in-tablet hide-in-mobile hide-in-small-mobile" (click)="hideDropDown();showTagView = 'Choose'"></div>
        <div class="tool-group-buttons-container" style="margin-left: auto;" [ngClass]="{'ng-xhide-btn': showTagView === 'Line' || showTagView === 'Signature'}">
          <div class="tool-group-buttons-scroll">
            <div
              data-element="signatureToolGroupButton"
              class="tool-group-button "
              
            >
              <button
                class="Button"
                data-element="signatureToolGroupButton"
                aria-label="line"
                aria-keyshortcuts="L"
                [ngClass]="{'active-btn': showTagView === 'Line'}"
                (click)="showTag('Line')"
              >
                <div class="Icon">
                  <svg
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 640 512"
                  >
                    <path
                      class="cls-1"
                      d="M640 247.5v17a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-17a16 16 0 0 1 16-16h608a16 16 0 0 1 16 16z"
                       
                    ></path>
                  </svg>
                </div>
              </button>
            </div>

            <div
              data-element="signatureToolGroupButton"
              class="tool-group-button active"
            >
              <button
                class="Button "
                [ngClass]="{'active-btn': showTagView === 'Signature'}"
                data-element="signatureToolGroupButton"
                aria-label="Signature"
                aria-keyshortcuts="S"
                (click)="showTag('Signature')"
              >
                <div class="Icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <title>icon - tool - signature</title>
                    <path
                      class="cls-1"
                      d="M20,12.66a1,1,0,0,0-1.27.7c-.21.77-1,3-2.39,3.45.08-.42.22-1,.32-1.33.41-1.58.71-2.71-.23-3.25a2,2,0,0,0-2.79.42,4.84,4.84,0,0,0-.55.93,7.14,7.14,0,0,1-2.18,2.81,3.12,3.12,0,0,1-1.12.33,2.47,2.47,0,0,1-1-.5,1.46,1.46,0,0,1-.21-.28c5.29-5.08,5.58-9.51,5.52-10.84a3.59,3.59,0,0,0-1.21-2.91A1,1,0,0,0,12.05,2c-2.86.59-4.63,4-5.57,10.83l-.05.25a7.89,7.89,0,0,0-.17,2.19L5.43,16A4.18,4.18,0,0,1,4.12,17a1.25,1.25,0,0,1,.19-.69A1,1,0,0,0,4,14.86a1.06,1.06,0,0,0-1.44.27,2.7,2.7,0,0,0,.18,3.48A1.8,1.8,0,0,0,3.94,19a4.45,4.45,0,0,0,2.88-1.54l.2-.17a2.09,2.09,0,0,0,.24.28A4.23,4.23,0,0,0,9.6,18.72,4.81,4.81,0,0,0,12.13,18a8.11,8.11,0,0,0,2.47-2.94c-.42,1.57-.64,2.58-.14,3.27a1.29,1.29,0,0,0,.94.54c2.37.27,4.35-1.6,5.29-5A1,1,0,0,0,20,12.66ZM11.87,4.23A4.1,4.1,0,0,1,12,5.42c0,1-.31,3.91-3.47,7.57C9,9.48,10,5.33,11.87,4.23Zm10.07,6.28a1.46,1.46,0,0,1-2.9,0,1.45,1.45,0,0,1,2.9,0Z"
                    ></path>
                    <rect
                      class="cls-1"
                      x="3.45"
                      y="19.99"
                      width="16.66"
                      height="2.01"
                    ></rect>
                  </svg>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <div
          class="CustomElement "
         
        >
          <div class="ToolsOverlayContainer">
            <div class="Overlay ToolsOverlay" data-element="toolsOverlay">
              
              <div class="tools-container">
                <div class="selected-signature-row" *ngIf="showTagView === 'Signature'">
                  <button
                    class="signature-row-content add-btn"
                    (click)="openModalWithComponent()"
                  >
                    Add New Signature
                  </button>
                  <div class="dropdown" > 
                    <button class="dropbtn" (click)="openSignatureDropDown()"> 
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" >
                        <path class="cls-1" d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z"  ></path>
                      </svg>
                    </button> 
                    <span [hidden]="!showSignatureDropDown">
                    <div class="dropdown-content" id='dropDownTag'  [style.left]="dropDownWidth" [ngStyle]="{'left': showSignatureDropDown ? dropDownWidth:'auto'}" >   

                        <a *ngIf="listOfSignature.length < 1" > 
                          Not found!

                          </a> 
                        <a  *ngFor="let item of listOfSignature; let i=index"> 
                          <div class="delete-btn" (click)="deleteSign(i)">
                            
                            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" >
                              <path class="cls-1" d="M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"  ></path>
                            </svg>
                          
                          </div>
                            <img [src]="item.url" (click)="selectSignature(i)"
                            width="20" height="15" class="drop-img"> 

                          </a> 
                          
                        </div> 
                      </span>
                  </div> 
                  
                </div>
                <div class="selected-signature-row"  *ngIf="showTagView != 'Signature'">
                  <span *ngIf="showTagView != 'Line'" >
                    <div class="hide-on-mobile-ngx-pdf" style="display: flex;
                    width: 15px;
                    float: left;
                    margin-right: 5px;">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="hide-on-mobile-ngx-pdf">
                        <path  d="M448 208v96c0 13.3-10.7 24-24 24H224v103.8c0 21.4-25.8 32.1-41 17L7 273c-9.4-9.4-9.4-24.6 0-34L183 63.3c15.1-15.1 41-4.4 41 17V184h200c13.3 0 24 10.7 24 24z" class="cls-1 hide-on-mobile-ngx-pdf"></path>
                      </svg> 
                    </div>
                    {{ showTagView }} 
                  </span>
                  <button
                    class="signature-row-content add-btn"
                    *ngIf="showTagView === 'Line'"
                    (click)="getLineImage()"
                  >
                    Add Line
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="divider"  style="margin-right: auto;"></div>
        <span style="display: flex" *ngIf="isEnableDoneBtn">
          <div
            data-element="signatureToolGroupButton"
            class="tool-group-button active"
          >
            <button
              class="Button"
              data-element="signatureToolGroupButton"
              aria-label="apply"
              aria-keyshortcuts="D"
              (click)="donePdf()"
            >
              <div class="Icon">
                <svg
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    class="cls-1"
                    d="M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"
                  ></path>
                </svg>
              </div>
            </button>
          </div>
          <div
            data-element="signatureToolGroupButton"
            class="tool-group-button active"
          >
            <button
              class="Button"
              data-element="signatureToolGroupButton"
              aria-label="cancel"
              aria-keyshortcuts="C"
              (click)="cancel()"
            >
              <div class="Icon" style="margin-left: 4px; margin-bottom: 3px">
                <svg
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 412 512"
                >
                  <path
                    class="cls-1"
                    d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"
                  ></path>
                </svg>
              </div>
            </button>
          </div>
        </span>
        <div
          class="spacer hide-in-tablet hide-in-mobile hide-in-small-mobile"
          (click)="hideDropDown()"
        ></div>
      <!-- </span> -->
        <span style="display: flex">
          <div
            data-element="signatureToolGroupButton"
            class="tool-group-button active"
          >
            <button
              class="Button active"
              data-element="menuButton2"
              aria-label="Menu"
              (click)="setShowSettingMenu()"
            >
              <div class="Icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>icon - header - settings - line</title>
                  <path
                    class="cls-1"
                    d="M12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Zm8.42-.6-.5-.29a7.74,7.74,0,0,0,0-2.22l.5-.29a2,2,0,0,0,.73-2.74l-1-1.72a2.06,2.06,0,0,0-2.73-.74l-.53.31A8.07,8.07,0,0,0,15,4.6V4a2,2,0,0,0-2-2H11A2,2,0,0,0,9,4v.6A8.07,8.07,0,0,0,7.1,5.71L6.57,5.4a2.07,2.07,0,0,0-2.73.73l-1,1.73a2,2,0,0,0,.73,2.74l.5.29a7.74,7.74,0,0,0,0,2.22l-.5.29a2,2,0,0,0-.73,2.74l1,1.73a2.05,2.05,0,0,0,2.72.73l.53-.31A8.07,8.07,0,0,0,9,19.4V20a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2v-.6a8.07,8.07,0,0,0,1.9-1.11l.53.31a2.07,2.07,0,0,0,2.73-.73l1-1.73A2,2,0,0,0,20.42,13.4Zm-2.59-2.78A5.86,5.86,0,0,1,18,12a5.92,5.92,0,0,1-.17,1.38,1,1,0,0,0,.47,1.11l1.12.64-1,1.73-1.15-.66a1,1,0,0,0-1.19.15,6.05,6.05,0,0,1-2.38,1.39,1,1,0,0,0-.71,1V20H11V18.7a1,1,0,0,0-.71-1,6.05,6.05,0,0,1-2.38-1.39,1,1,0,0,0-.69-.28,1,1,0,0,0-.5.13l-1.14.67-1-1.73,1.12-.65a1,1,0,0,0,.47-1.11A5.92,5.92,0,0,1,6,12a5.86,5.86,0,0,1,.17-1.38A1,1,0,0,0,5.7,9.51L4.58,8.86l1-1.73,1.15.67a1,1,0,0,0,1.19-.15,6.05,6.05,0,0,1,2.38-1.39,1,1,0,0,0,.71-1V4h2V5.3a1,1,0,0,0,.71,1,6.05,6.05,0,0,1,2.38,1.39,1,1,0,0,0,1.19.15l1.14-.66,1,1.73-1.12.64A1,1,0,0,0,17.83,10.62Z"
                  ></path>
                </svg>
              </div>
            </button>
          </div>
          <!-- menu -->
          <div [hidden]="!showSettingMenu">
            <div
              class="Overlay FlyoutMenu"
              data-element="menuOverlay"
              role="listbox"
              aria-label="Menu"
              style="left: auto; right: 2px; top: 46px"
            >
              <input
                type="file"
                style="display: none"
                id="choosePdfFile"
                (change)="handleUpload($event)"
                accept=".pdf"
              />
              <button
                class="Button ActionButton row"
                data-element="fullscreenButton"
                aria-label="Full screen"
                role="option"
                id="chooseFile"
              >
                <div class="Icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path
                      class="cls-1"
                      d="M464,128H272L217.37,73.37A32,32,0,0,0,194.74,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128Zm0,272H280V320h48.88a12,12,0,0,0,8.45-20.52L265,227.71a12.81,12.81,0,0,0-18,0h0l-72.31,71.77A12,12,0,0,0,183.12,320H232v80H48V112H188.12l54.63,54.63A32,32,0,0,0,265.38,176H464Z"
                    ></path>
                  </svg>
                </div>
                <span>{{ chooseFileButtonTitle }}</span>
              </button>

              <button
                class="Button ActionButton row"
                data-element="downloadButton"
                aria-label="Download"
                role="option"
                *ngIf="exportPdf"
                (click)="onExportPdf()"
              >
                <div class="Icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                  >
                    <path
                      class="cls-1"
                      d="M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM272 80v80H144V80h128zm122 352H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h42v104c0 13.255 10.745 24 24 24h176c13.255 0 24-10.745 24-24V83.882l78.243 78.243a6 6 0 0 1 1.757 4.243V426a6 6 0 0 1-6 6zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 128c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z"
                    ></path>
                  </svg>
                </div>
                <span>{{ exportPdfButtonTitle }}</span>
              </button>
              <button
                class="Button ActionButton row"
                data-element="downloadButton"
                aria-label="Download"
                role="option"
                *ngIf="exportSignatures"
                (click)="exportSignatureList()"
              >
                <div class="Icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      d="M572.29 279.06l-71.77-72.31c-7.55-7.6-20.52-2.26-20.52 8.45v48.88h-96v-132.1c0-12.7-5.17-25-14.17-33.99L285.94 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h287.94c26.5 0 48.07-21.5 48.07-47.99V360.07h-48v103.94H47.99V48.09h159.97v103.98c0 13.3 10.7 23.99 24 23.99H336v88.01H172c-6.63 0-12 5.37-12 12v24c0 6.63 5.37 12 12 12h308v48.88c0 10.71 12.97 16.05 20.52 8.45l71.77-72.31c4.95-4.99 4.95-13.04 0-18.03zM255.95 128.07V51.99l76.09 76.08h-76.09z"
                      class="cls-1"
                    ></path>
                  </svg>
                </div>
                <span>{{ exportSignatureButtonTitle }}</span>
              </button>

              <button
                class="Button ActionButton row"
                data-element="downloadButton"
                aria-label="Download"
                role="option"
                (click)="download()"
              >
                <div class="Icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <title>icon - header - download</title>
                    <path
                      class="cls-1"
                      d="M11.55,17,5.09,9.66a.6.6,0,0,1,.45-1H8.67V2.6a.6.6,0,0,1,.6-.6h5.46a.6.6,0,0,1,.6.6V8.67h3.13a.6.6,0,0,1,.45,1L12.45,17A.6.6,0,0,1,11.55,17ZM3.11,20.18V21.6a.4.4,0,0,0,.4.4h17a.4.4,0,0,0,.4-.4V20.18a.4.4,0,0,0-.4-.4h-17A.4.4,0,0,0,3.11,20.18Z"
                    ></path>
                  </svg>
                </div>
                <span>{{ downloadButtonTitle }}</span>
              </button>

              <button
                class="Button ActionButton row"
                data-element="downloadButton"
                aria-label="Download"
                role="option"
                (click)="getData()"
              >
                <div class="Icon">
                  <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 432" >
                    <path  d="M35.5 279.9l148-148.4c4.7-4.7 12.3-4.7 17 0l148 148.4c4.7 4.7 4.7 12.3 0 17l-19.6 19.6c-4.8 4.8-12.5 4.7-17.1-.2L218 219.2V468c0 6.6-5.4 12-12 12h-28c-6.6 0-12-5.4-12-12V219.2l-93.7 97.1c-4.7 4.8-12.4 4.9-17.1.2l-19.6-19.6c-4.8-4.7-4.8-12.3-.1-17zM12 84h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12H12C5.4 32 0 37.4 0 44v28c0 6.6 5.4 12 12 12z" class="cls-1"></path>
                  </svg>
                </div>
                <span>Load Assigned Pdf</span>
              </button>

              <button
                class="Button ActionButton row"
                data-element="downloadButton"
                aria-label="Download"
                role="option"
                (click)="onSavePdfData()"
              >
                <div class="Icon">
                  <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" >
                    <path  d="M528 288h-92.1l46.1-46.1c30.1-30.1 8.8-81.9-33.9-81.9h-64V48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v112h-64c-42.6 0-64.2 51.7-33.9 81.9l46.1 46.1H48c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48zm-400-80h112V48h96v160h112L288 368 128 208zm400 256H48V336h140.1l65.9 65.9c18.8 18.8 49.1 18.7 67.9 0l65.9-65.9H528v128zm-88-64c0-13.3 10.7-24 24-24s24 10.7 24 24-10.7 24-24 24-24-10.7-24-24z" class="cls-1"></path>
                  </svg>
                </div>
                <span>Save</span>
              </button>
            </div>
          </div>
        </span>
      </div>
    </div>
  </div>
  <app-side-nav
                [sidenavTemplateRef]="navContent"
                [direction]="'left'"
                [navWidth]="88"
                [duration]="0.5"
  ></app-side-nav>
<div id="pdf-page" cdkDropListGroup>

  <div
    *ngFor="let item of done; let i = index"
    style="z-index: 2; position: absolute"
  >
    <div
      [id]="'item' + i"
      [style.transform]="
        'translate3d(' +
        (offsetLeft + item?.coordinates?.left) +
        'px, ' +
        item?.coordinates?.top +
        'px, 0px)'
      "
      *ngIf="item.page === page"
      (cdkDragEnded)="dragEndOfDropedItems($event, i)"
      cdkDrag
    >
      <h2
        class="droped-item"
        [ngStyle]="{ 'background-color': item.color ? item.color : 'green' }"
      >
        <div
          style="
            padding: 3px 4px 0px 4px;
            margin: 2px;
            border-radius: 4px;
            width: 35px;
            float: left;
          "
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
            <path
              d="M637.2 199.8c-.9-.9-3-2.5-5.7-2.2-36.2 2.4-84.6 29.9-123.4 51.9-16 9.1-29.8 16.9-41.1 22-30.7 14-57.1 26.2-81.4 26.2-10.6 0-18.5-3-23.8-9.3-9.5-11-9.3-29.7-6.1-54.3 3.7-28.4.1-50.5-9.7-61.3-6-6.5-14.5-9.3-25.5-8.6-27.8 1.6-76.6 39-168.7 129.1l-27.4 26.9L181 175.9c13.2-33.5 4-70.1-23.3-93.1-21.8-18.4-58.8-29.2-97.7-4L4 117.1c-4 2.6-5.1 7.8-2.7 11.6L18.9 157c1.2 1.9 3 3.2 5.2 3.7 2.1.4 4.3.1 6.2-1.1L89.6 119c5.4-3.4 11.2-5.1 17-5.1 7 0 13.9 2.5 19.7 7.4 10.6 9 14.2 23.1 9.1 36.1L34.6 413.6c-2.9 7.3-1.7 17.3 3 24.3 3.1 4.6 9 10.1 19.9 10.1 6.6 0 12.8-2.6 17.4-7.3 43.5-44.2 158.5-157.2 217.3-205l14.8-12-1.5 19.2c-2.1 27.9-2.5 57.2 19 81.2 14.1 15.7 34.7 23.7 61.2 23.7 34.8 0 67.2-14.9 101.6-30.6 10.5-4.8 25-13.4 40.3-22.5 35.2-20.9 75.1-44.5 104.4-47 4.7-.4 8.1-3.8 8.1-8.2V206c-.1-2.3-1.1-4.6-2.9-6.2z"
              class="cls-1"
            ></path>
          </svg>
        </div>
      </h2>
      <div class="cross-icon" (click)="onFixPoint(i)">
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <path
            class="cls-1"
            d="M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"
          ></path>
        </svg>
      </div>
    </div>
  </div>
  <div *ngFor="let item of donePoints; let i = index" style="z-index: 2; position: absolute">
    <div
      [id]="'item' + i"
      *ngIf="item.page === page && !item.isSigned"
      (click)="openModalForSign(i)"
      [style.transform]="
        'translate3d(' +
        (offsetLeft + item?.coordinates?.left) +
        'px, ' +
        item?.coordinates?.top +
        'px, 0px)'
      "
    >
      <h2
        class="droped-item"
        *ngIf="getScrollOffsetCheck(item)"
        [ngStyle]="{ 'background-color': item.color ? item.color : 'green' }"
      >
      <div
      style="
        padding: 3px 4px 0px 4px;
        margin: 2px;
        border-radius: 4px;
        width: 35px;
        float: left;
      "
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
        <path
          d="M637.2 199.8c-.9-.9-3-2.5-5.7-2.2-36.2 2.4-84.6 29.9-123.4 51.9-16 9.1-29.8 16.9-41.1 22-30.7 14-57.1 26.2-81.4 26.2-10.6 0-18.5-3-23.8-9.3-9.5-11-9.3-29.7-6.1-54.3 3.7-28.4.1-50.5-9.7-61.3-6-6.5-14.5-9.3-25.5-8.6-27.8 1.6-76.6 39-168.7 129.1l-27.4 26.9L181 175.9c13.2-33.5 4-70.1-23.3-93.1-21.8-18.4-58.8-29.2-97.7-4L4 117.1c-4 2.6-5.1 7.8-2.7 11.6L18.9 157c1.2 1.9 3 3.2 5.2 3.7 2.1.4 4.3.1 6.2-1.1L89.6 119c5.4-3.4 11.2-5.1 17-5.1 7 0 13.9 2.5 19.7 7.4 10.6 9 14.2 23.1 9.1 36.1L34.6 413.6c-2.9 7.3-1.7 17.3 3 24.3 3.1 4.6 9 10.1 19.9 10.1 6.6 0 12.8-2.6 17.4-7.3 43.5-44.2 158.5-157.2 217.3-205l14.8-12-1.5 19.2c-2.1 27.9-2.5 57.2 19 81.2 14.1 15.7 34.7 23.7 61.2 23.7 34.8 0 67.2-14.9 101.6-30.6 10.5-4.8 25-13.4 40.3-22.5 35.2-20.9 75.1-44.5 104.4-47 4.7-.4 8.1-3.8 8.1-8.2V206c-.1-2.3-1.1-4.6-2.9-6.2z"
          class="cls-1"
        ></path>
      </svg>
    </div>
      </h2>
    </div>
  </div>


 

  
  <div class=" section-1" id="section-1">

    <app-selection-area
      [hidden]="!showSelectArea"
      (click)="hideDropDown()"
      [width]="selectTagWidthInit"
      [height]="selectTagHeightInit"
      [left]="x_axisInit"
      [top]="y_axisInit"
      (widthEvent)="receiveWidth($event)"
      (heightEvent)="receiveHeight($event)"
      (offsetOfSelect)="offsetOfSelect($event)"
    ></app-selection-area>
    <!-- #selectArea  -->

    <div
      cdkDropList
      id="list-2"
      cdkDropListConnectedTo="list-1"
      [cdkDropListData]="done"
      (cdkDropListDropped)="drop($event)"
      class="pdf-boundary"
    >
      <pdf-viewer
        [src]="src"
        #viewer
        style="
          background-color: #00000033;
          padding: 100px;
        "
        [original-size]="true"
        [zoom]="zoom"
        [fit-to-page]="false"
        (page-rendered)="pageRendered($event)"
        [(page)]="page"
        [show-all]="false"
        (click)="hideDropDown()"
      >
      </pdf-viewer>
    </div>
  </div>

  <div class="footer-sdk">
    <div data-element="pageNavOverlay" class="Overlay PageNavOverlay">
      <button
        class="side-arrow-container"
        (click)="changePage(-1)"
        aria-label="Previous page"
      >
        <div class="Icon side-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
            <title>icon - chevron - left</title>
            <path class="cls-1" d="M7.5,2l-4,4,4,4,1-1-3-3,3-3Z"></path>
          </svg>
        </div>
      </button>
      <div class="formContainer">
        <form>{{ page }} / {{ pdfPages?.length }}</form>
      </div>
      <button
        class="side-arrow-container"
        (click)="changePage(1)"
        aria-label="Next page"
      >
        <div class="Icon side-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
            <title>icon - chevron - right</title>
            <path class="cls-1" d="M4.5,10l4-4-4-4-1,1,3,3-3,3Z"></path>
          </svg>
        </div>
      </button>
    </div>
  </div>
</div>
</span>
<ng-template #navContent>
  <app-side-nav-content></app-side-nav-content>
</ng-template>
